export default __webpack_public_path__ + "static/image-popup-bg-93d7a2be70d072905070d07b3f107c18.jpeg";